<template>
  <v-layout :show-navigation="false">
    <div class="col ma-login">
      <div class="panel">
        <div class="head-page-title hide-for-small-only">
          <h1 class="main-title">Login MijnArrivaZakelijk</h1>
        </div>
        <login-form />
        <div class="forgot-password">
          <router-link :to="{ name: 'forgot-password'}">Wachtwoord vergeten?</router-link>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import VLayout from '../layouts/Default'
import LoginForm from '../components/forms/LoginForm'

export default {
  name: 'LoginPage',
  components: {
    VLayout,
    LoginForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/LoginPage.vue